// extracted by mini-css-extract-plugin
export default {"container":"AppointmentWlist_container__wCzKk"};